// extracted by mini-css-extract-plugin
export var content = "siteHeader-module--content--3cfc6";
export var header = "siteHeader-module--header--81794";